ko.bindingHandlers.tristate = {
    init: function (element, valueAccessor, allBindingsAccessor, data) {
        // Extract necessary values
        const observable = (typeof valueAccessor() === 'function') ? valueAccessor() : null;
        const value = ko.unwrap(valueAccessor());
        const options = allBindingsAccessor().values;
        const optionsText = allBindingsAccessor().optionsText;
        const optionsValue = allBindingsAccessor().optionsValue;
        const elem = element;

        // Add necessary classes and attributes
        elem.classList.add('ko-tristate', 'user-select-none');
        elem.setAttribute('tabindex', '0');

        // Create and append span element
        const span = document.createElement('span');
        span.classList.add('user-select-none');
        span.textContent = options.find(i => i[optionsValue] === value)[optionsText];
        if (window.getComputedStyle(elem).textAlign === 'left') {
            span.style.left = window.getComputedStyle(elem).paddingLeft;
        }
        if (window.getComputedStyle(elem).textAlign === 'right') {
            span.style.right = window.getComputedStyle(elem).paddingRight;
        }
        span.style.top = parseInt(window.getComputedStyle(elem).paddingTop) + 1 + "px";
        elem.appendChild(span);

        // Add event listener for click
        const eventfunction = (evt) => {
            const currentElem = evt.currentTarget;
            const currentIndex = options.indexOf(options.find(i => i[optionsText] === currentElem.querySelector('span').textContent));
            const newVal = (options[currentIndex + 1]) ? options[currentIndex + 1] : options[0];
            const propertyToUpdate = getPropertyName(currentElem);

            if (observable && typeof observable === 'function') {
                data[getPropertyName(currentElem)](newVal[optionsValue]);
            } else {
                if (propertyToUpdate.includes('.')) {
                    const [object, field] = propertyToUpdate.split('.');
                    data[object][field] = newVal[optionsValue];
                }
                data[propertyToUpdate] = newVal[optionsValue];
            }

            currentElem.querySelector('span').textContent = newVal[optionsText];
        }
        elem.addEventListener('click', eventfunction);

        // Add event listener for keypress
        elem.addEventListener('keypress', function (evt) {
            if (evt.keyCode == 32) {
                eventfunction(evt);
            }
        });

        // Function to extract property name
        function getPropertyName(elem) {
            return elem.getAttribute('data-bind').split('tristate:')[1].split(',')[0].trim();
        }
    },
    update: function (element, valueAccessor, allBindingsAccessor, data) {
        const value = ko.unwrap(valueAccessor());
        const options = allBindingsAccessor().values;
        const optionsText = allBindingsAccessor().optionsText;
        const optionsValue = allBindingsAccessor().optionsValue;
        const elem = element;

        elem.querySelector('span').textContent = options.find(i => i[optionsValue] === value)[optionsText];
    }
};